import React from "react";
import T from "../TheTool";
import GUI_InputTextArea from "./GUI_InputTextArea";
import GUI_2Buttons from "./GUI_2Buttons";

function GUI_2Buttons_ClearClick(props) {
	var label1 = T.getValue(props.label1, "Input");
	var label2 = T.getValue(props.label2, "");
	var placeholder1 = T.getValue(props.placeholder, "");
	//
	var but1_label = T.getValue(props.but1_label, "Clear");
	var but2_label = T.getValue(props.but2_label, "Calculate");
	var but1_ratio = T.getValue(props.but1_ratio, 1);
	var but2_ratio = T.getValue(props.but2_ratio, 3);

	const buttonClick1 = () => {
		props.guiTxtAreaChange("");
	};

	const buttonClick2 = () => {
		props.buttonClick(); //Calculate
	};

	return (
		<div>
			<GUI_InputTextArea
				id="inputItemList"
				className="textarea_001"
				placeholder={placeholder1}
				style={{ minHeight: "308px", whiteSpace: "pre-line" }}
				// placeholder={"name,weight,value\nname,weight,value\nname,weight,value"}
				// defaultValue=""
				// value={guiTxtArea}
				// onChange={guiTxtAreaChange}
				area1Change={props.guiTxtAreaChange}
				text1={props.guiTxtArea}
				label={label1}
				label2={label2}
			/>
			<GUI_2Buttons
				buttonClick1={buttonClick1}
				buttonClick2={buttonClick2}
				label1={but1_label}
				label2={but2_label}
				ratio1={but1_ratio}
				ratio2={but2_ratio}
			/>
		</div>
	);
}

export default GUI_2Buttons_ClearClick;
